const _ = require('lib/underscore')

module.exports = function getUserActiveImage(user) {
    // get the user's active image
    const images = user.images || []

    const active = _.findWhere(images, { active: true })

    return active
}
